import * as constants from "../constants/movieCinemaConstants";
import actionCreators from "../../../itemList/actions/tabbedMoviesActionCreators";

export default actionCreators(constants);
